<div class="game-type">

  <div class="game-type__inner">
      <div class="animated-logo-container">
        <main class="logo-container"  lottie [options]="options" (animationCreated)="animationCreated($event)"></main>
      </div>
      <div class="game-type__buttons">
        <a [routerLink] = "['/play']">
          <img class="" src="assets/practice-play.png" />
        </a>

        <a (click)="buttonClick('/rhythms?view=rhythms')">
          <img class="" src="assets/rhythm-deck-logo.png" />
        </a>

        <!-- <a (click)="buttonClick('/starter-kit')"> -->
        <a (click)="buttonClick('/rhythms?view=12 lead')">
          <img class="" src="assets/lead-logo.png" />
        </a>
      </div>

      <div class="game-type__inner-bottom">
        <a href="https://www.skillstat.com/dashboard/" target="_parent">
          <div class="logo"></div>
        </a>

        <!-- <a (click)="buttonClick('/certifications')" class="certification-button">Certification</a> -->
      </div>

  </div>

</div>